"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExpandableContent = require("../../../ExpandableContent");

var _ExpandableSummaryContent = _interopRequireDefault(require("./ExpandableSummaryContent"));

var ExpandableSidebarListItem = function ExpandableSidebarListItem(_ref) {
  var children = _ref.children,
      marketingIcon = _ref.marketingIcon,
      label = _ref.label,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "marketingIcon", "label"]);
  return /*#__PURE__*/_react.default.createElement(_ExpandableContent.Details, (0, _extends2.default)({
    summaryContent: /*#__PURE__*/_react.default.createElement(_ExpandableSummaryContent.default, {
      label: label,
      marketingIcon: marketingIcon
    })
  }, rest), children);
};

ExpandableSidebarListItem.propTypes = {
  /** Children component to render when <details> is expanded */
  children: _propTypes.default.node.isRequired,

  /** Text that is visible whether content is expanded or collapsed */
  label: _propTypes.default.string.isRequired,

  /** Icon that appears to the left of the `label` text */
  marketingIcon: _propTypes.default.string.isRequired
};
var _default = ExpandableSidebarListItem;
exports.default = _default;